<template>
  <div
    :class="{
      'v-upload-container': card,
      'text-right__top':right,
      'text-right__document':isShowDetail
    }">
    <div
      :class="{
        'upload-container': card,
        'width-full': widthFull
      }">
      <el-upload
        ref="upload"
        action
        :drag="drag"
        :disabled="disabled"
        :show-file-list="false"
        :data="uploadData"
        :before-upload="beforeUpload"
        :accept="accept"
        :multiple="isMultiple"
        :on-change="handleChange"
      >
        <template v-if="card">
          <div
            class="upload-card"
            :class="{
              'noBorder': noBorder
            }">
            <template v-if="localData.thumb_url">
              <img
                v-if="isExcel||isPdf"
                class="img-pdf"
                src="@assets/images/icon/pdf.png"
                @click="handleDock" />
              <img
                v-else
                ref="img"
                :src="src_url"
                :onerror="imgOnerror()"
                @click="handleDock"
              />
            </template>
            <!-- <i
              v-if="localData.thumb_url"
              class="el-icon-close delete-icon"
              @click.stop="handlerRemove"
            ></i> -->
            <!-- 需要樣式兼容 -->
            <!-- <el-image
              v-if="localData.thumb_url"
              :src="localData.thumb_url"></el-image> -->
            <div
              v-else
              class="add-icon"></div>
            <div
              v-if="isBlog && !disabled && localData.url"
              class="upload-btn-box"
              @click.stop="handlerDelete">
              <img
                src="@assets/images/icon/delete.png"
                alt="delete" />
            </div>
          </div>
        </template>
        <template v-else>
          <v-button
            ref="upload-button"
            :icon="icon"
            :disabled="disabled"
            :plain="btnPlain"
            :gray="gray"
            :blue="blue"
            :green="green"
            :type="isShowDetail?'':btnType"
          >{{ isDetailImgBtn?'':label }}</v-button
          >
        </template>
        <slot></slot>
      </el-upload>
    </div>
    <div
      v-if="card && localData.url && !isBlog && !hideBtn&&!isShowDetail"
      class="upload-btn-container">
      <div
        class="upload-btn-box"
        @click.stop="handlerView"
      >
        <img
          src="@assets/images/icon/view.png"
          alt="view" />
      </div>
      <div
        v-if="!disabled"
        class="upload-btn-box"
        @click.stop="handlerDelete">
        <img
          src="@assets/images/icon/delete.png"
          alt="delete" />
      </div>
    </div>
  </div>
</template>
<script>
import {uploadOrderFile} from '@api/order'
import {heicChange} from '@/utils/heic2any'
import pdf_icon from '@assets/images/icon/pdf.png'

export default {
  name: 'VUploadList',
  props: {
    otherData: {
      type: Object,
      default: () => ({}),
    },
    uploadData: {
      type: Object,
      default: () => ({}),
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    drag: {
      type: Boolean,
      default: false,
    },
    right: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: 'Upload file',
    },
    card: {
      type: Boolean,
      default: false,
    },
    isDetailImgBtn: {
      type: Boolean,
      default: false,
    },
    isCarVehicle: {
      type: Boolean,
      default: false,
    },
    isMultiple: {
      type: Boolean,
      default: false,
    },
    isUploadVideo: {
      type: Boolean,
      default: false,
    },
    fileData: {
      type: Object,
      default: () => ({}),
    },
    btnType: {
      type: String,
      default: 'primary',
    },
    gray: {
      type: Boolean,
      default: false,
    },
    green: {
      type: Boolean,
      default: false,
    },
    blue: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: String,
      default: ''
    },
    accept: {
      type: String,
      default: ''
    },
    isUploadType: {
      type: Boolean,
      default: false,
    },
    btnPlain: {
      type: Boolean,
      default: false,
    },
    direct: {
      type: Number,
      default: 1, // 只上傳不入庫
    },
    notUpload: {
      type: Boolean,
      default: false,
    },
    widthFull:{
      type: Boolean,
      default: false,
    },
    isBlog: {
      type: Boolean,
      default: false
    },
    hideBtn: {
      type: Boolean,
      default: false
    },
    promise:{
      type: Function,
      default: null
    },
    noBorder:{
      type: Boolean,
      default: false
    },
    isExcel:{
      type: Boolean,
      default: false
    },
    isShowDetail:{
      type: Boolean,
      default: false
    },
    isSign:{
      type: Number,
      default: 0
    },
    isEnquiry:{
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      isLocal: false,
      localData: {
        thumb_url: '',
        url: '',
      },
      times: 0,
      uploadedFiles: new Set(), // 用于存储已上传文件的唯一标识
    }
  },
  computed: {
    src_url() {
      return this.isLocal ? this.localData.local_url : this.localData.thumb_url
    },
    isPdf(){
      let {client_name} = this.fileData
      if(String(client_name).toLowerCase().indexOf('.pdf') != -1) {
        return true
      }
      return false
    }
  },
  watch: {
    fileData: {
      deep: true,
      immediate: true,
      handler(val) {
        const result =
          val && JSON.stringify(val) != '{}' && !(val instanceof Array)
        if (result) {
          this.localData = Object.assign(this.localData, val)
        } else {
          this.localData = {
            thumb_url: '',
            url: '',
          }
          this.isLocal = false
        }
      },
    },
  },
  methods: {
    handleDock(){
      if(this.isShowDetail)
        this.$emit('dock')
    },
    async beforeUpload(file){
      if(this.promise){
        const res = await this.promise(file)
        return res
      }else{
        if(file.name.toLowerCase().endsWith('.heic')){
          return heicChange(file)
        }
        return file
      }
    },
    currentClick() {
      this.$refs['upload-button'].currentClick()
    },
    handlerRemove() {
      this.localData.thumb_url = ''
      this.$emit('uploadSuccess', {
        data: {},
        result: '',
        otherData: this.otherData,
      })
    },
    handlerView() {
      window.open(this.localData.url, '_blank')
    },
    handlerDelete() {
      this.$emit('delete', {
        otherData: this.otherData
      })
    },
    isVideoFile(file) {
      return file.type.startsWith('video/')
    },
    handleChange(file, fileList) {
      fileList.forEach(async (item) => {
        const rawFile = item.raw // 获取原始文件对象
        // 检查文件是否已经上传过
        if (this.uploadedFiles.has(item.uid)) {
          return // 跳过已上传的文件
        }
        // 判断文件类型并处理
        if (this.isVideoFile(rawFile)) {
          this.uploadedFiles.add(item.uid) // 添加到已上传文件集合
          this.$emit('uploadVideoData', rawFile,{ otherData: this.otherData,})
        } else {
          this.uploadedFiles.add(item.uid) // 添加到已上传文件集合
          await this.customUpload(item)
        }
      })
    },

    // 自定义上传
    async customUpload(file) {
      let params = new FormData()
      params.append('file', file.raw) // 使用 raw 文件对象
      params.append('direct', this.direct) // 默认为 1
      params.append('is_sign', this.isSign) // 默认为 1

      // 处理其他上传参数
      if (this.isUploadType) {
        params.append('type', this.otherData.type) // 默认类型
      }

      if (this.direct == 0) {
        Object.keys(this.uploadData).forEach((key) => {
          params.append(key, this.uploadData[key])
        })
      }

      // 图片预览链接
      let result = {
        isImage: file.raw.type.indexOf('image') !== -1,
        isPDF: file.raw.type.indexOf('pdf') !== -1,
      }

      if (this.notUpload) {
        this.$emit('uploadForm', {
          file: file.raw,
          params,
          result,
          otherData: this.otherData,
        })
      } else {
        try {
          await this.network().uploadOrderFile(params, result) // 使用 await 处理异步上传
          console.log('上传成功')
        } catch (error) {
          console.error('上传失败', error)
        }
      }
    },

    imgOnerror(){
      // 图片加载错误处理
      this.$nextTick(() =>{
        if(this.times < 3){
          let img = this.$refs.img
          img.src = ''
          img.src = this.localData.thumb_url
          this.times ++
        }
      })
    },

    network() {
      return {
        uploadOrderFile: async (params, result) => {
          this.isLocal = false
          const { data } = await uploadOrderFile(params,this.isEnquiry)
          const { url, isImage, isPDF } = result
          this.isLocal = isImage
          if (isImage&&!this.right) {
            this.localData.thumb_url = url
            this.localData.local_url = isImage ? url : data.thumb_url // 使用本地圖片，避免不能即使獲取到遠程圖片問題
          }
          if(isPDF&&!this.right){
            this.localData.thumb_url = pdf_icon
            this.localData.local_url = pdf_icon
          }
          const dataResult = {
            ...data,
            path: data.name,
            thumb_url: isImage? url: data.thumb_url
          }
          this.$emit('uploadSuccess', {
            data: dataResult,
            result,
            otherData: this.otherData,
          })
        },
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.v-upload-container {
  display: flex;
  height: 100%;
  .upload-container {
    width: 335px;
    &>div{
      height: 100%;
    }
  }
  .upload-btn-container {
    display: flex;
    flex-direction: column;
    width: 46px;
    .upload-btn-box {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-left: 10px;
      margin-bottom: 10px;
      width: 36px;
      height: 36px;
      border-radius: 6px;
      background: #012a63;
      cursor: pointer;
      img {
        width: 30px;
        height: 30px;
      }
    }
  }
}
.text-right__top{
  text-align: right;
  margin-top: 10px;
}
.text-right__document{
  justify-content: end;
  margin-top: 10px;
  &:nth-child(1){
    margin-top: 0;
  }
}
.upload-card {
  z-index: 0;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 335px;
  height: 200px;
  border: 1px dashed #91939a;
  border-radius: 4px;
  img {
    max-width: 100%;
    max-height: 100%;
    z-index: 3;
  }
  .add-icon {
    width: 100%;
    height: 100%;
    &::before {
      z-index: -1;
      position: absolute;
      content: "";
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 50px;
      height: 1px;
      background: #979797;
    }
    &::after {
      z-index: -1;
      position: absolute;
      content: "";
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 1px;
      height: 50px;
      background: #979797;
    }
  }
  .upload-btn-box {
    z-index: 4;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 10px;
    right: 10px;
    width: 36px;
    height: 36px;
    border-radius: 6px;
    background: #012a63;
    cursor: pointer;
    img {
      width: 30px;
      height: 30px;
    }
  }
  &.noBorder{
    border: none;
    height: 100%;
  }
}
.delete-icon {
  position: absolute;
  right: 10px;
  top: 10px;
  font-size: 18px;
}

.width-full{
  width: 100% !important;
  /deep/.el-upload{
    width: 100%;
    height: 100%;
  }
  .upload-card{
    width: 100%
  }
}
</style>
